import { HttpResponse, SearchResponse } from "@/fetchInterceptor/AxiosMethod";

import { IFetchRequest, OrganizationEntity } from "./entity/OrganizationEntity";
import { SettingRequestModel } from "./entity/SettingRequestModel";
import { SettingResponseModel } from "./entity/SettingResponseModel";

export const TokenISettingService = "ISettingService";

export interface ISettingService {
  fetchOrganization(
    request: IFetchRequest,
    Keyword: string
  ): Promise<SearchResponse<OrganizationEntity>>;

  fetchSetting(
    request: IFetchRequest
  ): Promise<HttpResponse<SettingResponseModel>>;

  addSettingOrganization(
    request: IFetchRequest,
    payload: SettingRequestModel
  ): Promise<SearchResponse<number>>;
}
